import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

const Navbar = () => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState("");

  // Function to check login state
  const checkLoginState = () => {
    const token = localStorage.getItem("auth_token");
    const name = localStorage.getItem("user_name");
    if (token) {
      setIsLoggedIn(true);
      setUserName(name || "");
    } else {
      setIsLoggedIn(false);
      setUserName("");
    }
  };

  // Check login state on mount
  useEffect(() => {
    checkLoginState();

    // Listen for storage changes from other tabs or windows
    const handleStorageChange = (e) => {
      if (e.key === "auth_token" || e.key === "user_email") {
        checkLoginState();
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const handleButtonClick = () => {
    if (isLoggedIn) {
      // Logout
      localStorage.removeItem("auth_token");
      localStorage.removeItem("user_id");
      localStorage.removeItem("user_email");

      // Update localStorage with new profile info
      localStorage.removeItem('user_name');
      localStorage.removeItem('user_phone');
      localStorage.removeItem('user_country');

      setIsLoggedIn(false);
      setUserName("");
      // Logout
      window.location.href = "/home.html";
    } else {
      // Login
      window.location.href = "/login.html";
    }
  };

  return (
    <nav className="navbar">
       <div className="col-lg-12 col-sm-12 col-xs-12">
        <div className="col-lg-3 col-sm-5 col-xs-6">
          <img src="../img/logo-sm.png" alt="Cue Traders Logo" />
          <h1>Cue Traders</h1>
        </div>
        <div className="col-lg-9 col-sm-7 col-xs-6">
          <div className="links" align="right">
            {isLoggedIn && (
              <span style={{ marginRight: "15px", color: "#aaa" }}>
                {userName}
              </span>
            )} 
            <button
              onClick={handleButtonClick}
              className="btn-normal"
              style={{
                backgroundColor: isLoggedIn ? "#dc3545" : "#007bff",
                color: "#fff",
                border: "none",
                padding: "5px 15px",
                cursor: "pointer",
                borderRadius: "4px",
              }}
            >
              {isLoggedIn ? "Logout" : "Login"}
            </button>
          </div>
        </div>
        <div className="col-lg-9 col-sm-9 col-xs-12">
          <div className="links">
            <a href="/home.html">Home</a>
            <Link to="/stocks">Stocks</Link>
            <Link to="/portfolios">Portfolios</Link>
            {isLoggedIn && <a href="/profile.html">Profile</a>}
          </div>


        </div>
      </div>
    </nav>
  );
};

export default Navbar;

